export default "__VITE_ASSET__DIFi3AH5__"